import useFitText from "use-fit-text";

import { FormattedPriceCalculationResponse } from "../constants";
import { usePriceFinderStore } from "../store/store";

export const useFitPriceTextIntoPlanCard = () => {
    const { fontSize, ref } = useFitText({ resolution: 5 });
    const [{ billingCycle, priceCalcs }] = usePriceFinderStore();

    const sortOnTotal = (
        { formattedTotalPrice: priceA }: FormattedPriceCalculationResponse,
        { formattedTotalPrice: priceB }: FormattedPriceCalculationResponse
    ) => priceB.length - priceA.length;

    const sortOnAvg = (
        { formattedAvgPerUnitPrice: priceA }: FormattedPriceCalculationResponse,
        { formattedAvgPerUnitPrice: priceB }: FormattedPriceCalculationResponse
    ) => priceB.length - priceA.length;

    let highestDisplayPrice = "$0";
    const getPrice = (
        sortOn: (
            a: FormattedPriceCalculationResponse,
            b: FormattedPriceCalculationResponse
        ) => number
    ) => priceCalcs.slice().sort(sortOn)[0];

    if (priceCalcs.length) {
        if (billingCycle === "MONTHLY") {
            highestDisplayPrice =
                getPrice(sortOnAvg)?.formattedAvgPerUnitPrice || "";
        } else {
            highestDisplayPrice =
                getPrice(sortOnTotal)?.formattedTotalPrice || "";
        }
    }

    return { ref, fontSize, highestDisplayPrice };
};
